import { render, staticRenderFns } from "./AnAccordionItem.vue?vue&type=template&id=0be35b20&scoped=true&"
import script from "./AnAccordionItem.vue?vue&type=script&lang=js&"
export * from "./AnAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AnAccordionItem.vue?vue&type=style&index=0&id=0be35b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be35b20",
  null
  
)

export default component.exports